<style type="text/css">
  .v-btn-toggle.square-alignment{
    overflow:hidden;
    flex-wrap: wrap;
    border:solid 1px rgba(0,0,0,.3);
    display:flex;
    width: 180px;
  }
  .v-btn-toggle.square-alignment>.v-btn{
      width:33%;
      flex-grow: 1;
      border: none;
      border-radius: 0 !important;
    }
</style>
<template>
    <div>
        <div><label class="v-label theme--light pr-4">{{label}}</label></div>
        <div v-if="hint" v-text="hint" />
        <v-btn-toggle v-model="position" @change="$emit('input', position)" :mandatory="mandatory" color="zoezi-edit-color" class="square-alignment">
            <v-btn value="left top" small>
                <v-icon>mdi-arrow-top-left</v-icon>
            </v-btn>
            <v-btn value="center top" small>
                <v-icon>mdi-arrow-up</v-icon>
            </v-btn>
            <v-btn value="right top" small>
                <v-icon>mdi-arrow-top-right</v-icon>
            </v-btn>
            <v-btn value="left center" small>
                <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
            <v-btn value="center center" small>
                <v-icon>mdi-image-filter-center-focus</v-icon>
            </v-btn>
            <v-btn value="right center" small>
                <v-icon>mdi-arrow-right</v-icon>
            </v-btn>
            <v-btn value="left bottom" small>
                <v-icon>mdi-arrow-bottom-left</v-icon>
            </v-btn>
            <v-btn value="center bottom" small>
                <v-icon>mdi-arrow-down</v-icon>
            </v-btn>
            <v-btn value="right bottom" small>
                <v-icon>mdi-arrow-bottom-right</v-icon>
            </v-btn>
        </v-btn-toggle>
    </div>
</template>

<script>
export default {
    name: 'BackgroundPositionSetting',

    props: ['value', 'label', 'mandatory', 'hint'],
    data: () => ({
        position: null
    }),
    created() {
        this.position = this.value;
    }
}
</script>
